import { createFileRoute } from '@tanstack/react-router'
import { DocumentViewerPage } from 'pages/documentViewer/DocumentViewerPage'
import { documentViewerSearchParams } from 'routes/document-viewer/-searchParams'

export const Route = createFileRoute('/document-viewer/')({
  component: RouteComponent,
  validateSearch: documentViewerSearchParams,
  staticData: {
    layout: { showNavbar: false },
  },
})

function RouteComponent() {
  const { id, filename, title, fileFormat, pageRotations } = Route.useSearch()
  return (
    <DocumentViewerPage
      id={id}
      filename={filename}
      title={title}
      fileFormat={fileFormat}
      pageRotations={pageRotations}
    />
  )
}
